import { defineMessages } from 'react-intl';

/**
 * Localised strings for the attach panel and related error feedback.
 *
 * Includes modal UI labels (`title`, `image`, `photo`, `document`,
 * `location`, `max_size`) and validation error messages:
 * - `attach_error_size`: shown when the file exceeds `max_size`; accepts a
 *   `{size}` placeholder for the human-readable limit (e.g. "5 MB").
 * - `attach_error_type`: shown when the file mime type is not in
 *   `allowed_types`.
 * - `drop_hint`: label shown inside the footer drop-zone overlay while a file
 *   drag is active over the chat frame; instructs the user to release here.
 */
export const attachMessages = defineMessages({
	title: {
		id: 'attach.title',
		defaultMessage: 'Attach',
		description:
			'"Attach" text placed in modal header after click on attach icon',
	},
	image: {
		id: 'attach.image',
		defaultMessage: 'Image',
		description: '"Image" text placed in modal body in attach option list',
	},
	photo: {
		id: 'attach.photo',
		defaultMessage: 'Photo',
		description: '"Photo" text placed in modal body in attach option list',
	},
	document: {
		id: 'attach.document',
		defaultMessage: 'Document',
		description: '"Document" text placed in modal body in attach option list',
	},
	location: {
		id: 'attach.location',
		defaultMessage: 'Location',
		description: '"Location" text placed in modal body in attach option list',
	},
	max_size: {
		id: 'attach.max_size',
		defaultMessage: 'Max size allowed: {size}',
		description:
			'"Max size allowed" text placed in modal header in attach option list',
	},
	attach_error_size: {
		id: 'attach.error.size',
		defaultMessage: 'File too large, max {size}',
		description:
			'Error message shown when a pasted or selected file exceeds the configured max_size limit',
	},
	attach_error_type: {
		id: 'attach.error.type',
		defaultMessage: 'File type not allowed',
		description:
			'Error message shown when a pasted or selected file mime type is not in the allowed_types list',
	},
	drop_hint: {
		id: 'attach.drop_hint',
		defaultMessage: 'Release to attach file',
		description:
			'Label shown inside the SubmitForm drop-zone footer overlay while the user is dragging a file over the chat frame; instructs the user to drop the file in the footer area',
	},
});
